import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {List} from 'immutable';
import { jsxActions as headerActions} from '../../../actions/Header/headerActions';
import { jsxActions as fetchEntitiesActions }      from '../../../actions/FetchEntities/fetchEntitiesActions.js';
import { jsxActions as assetsViewActions }        from '../../../actions/LocationPage/AssetsView/assetsViewActions';
import { jsxActions as assetsToolsGridActions }        from '../../../actions/LocationPage/AssetsView/assetsToolsGridActions';
import {jsxActions as createToolActions} from '../../../actions/LocationPage/AssetsView/createToolActions';
import { jsxActions as reportMaintenanceActions }   from '../../../actions/Dialogs/ReportMaintenanceDialog/reportMaintenanceDialogActions';
import {gridsNames} from '../../../enums/gridsNames';
import ToolsView from '../../../components/LocationPage/AssetsView/ToolsView/toolsView';


function mapDispatchToProps(dispatch) {
  return {
    actions: {
      ...bindActionCreators(assetsViewActions, dispatch),
      fetchEntitiesActions:    bindActionCreators(fetchEntitiesActions, dispatch),
      headerActions:        bindActionCreators(headerActions, dispatch),
      assetsToolsGridActions:        bindActionCreators(assetsToolsGridActions, dispatch),
      createToolActions:        bindActionCreators(createToolActions, dispatch),
      reportMaintenanceActions:   bindActionCreators(reportMaintenanceActions, dispatch),
    }
  }
}

let ToolsViewContainer = connect(
  (state) => {
    let sGrid = state.grid.get(gridsNames.LOCATION_ASSET_TOOLS) ? state.grid.get(gridsNames.LOCATION_ASSET_TOOLS) : null;
    return {
      sGrid:                  sGrid,
      sHasRows:               sGrid && sGrid.get('rows') ? sGrid.get('rows').size > 0 : false,
      sSelectedRowsData:      sGrid ? sGrid.get('selectedRowsData') : List(),
      sData:                  state.locationPage.getIn(['assetsView', 'toolsView']),
      sLocationDetails:       state.locationPage.get('data').get('locationDetails'),
      sLoggedInUser :         state.login.get('loggedInUser'),
      sDataCreateTool:        state.locationPage.get('createToolData'),
      sReportMaintenanceDialogData: state.dialogs.get('reportMaintenanceDialog'),
    };
  },
  mapDispatchToProps
)(ToolsView);

export default ToolsViewContainer;




